import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
export const initialState = {
    loading: false,
    message: '',
    showMessage: false,
    filters: {
        startDate: null,
        endDate: null,
        products: [],
        sources: []
    },
    dropListProducts: [],
    dropListAffiliateSources: [],
    statistic: {
        dashboardGC: [],
        lineChart: {
            views: [],
            purchases: []
        },
        products: [],
        contributors: []
    }
}


export const getDropListProducts = createAsyncThunk('dashboard/getDropListProducts', async (_, { rejectWithValue }) => {
    try {
        return [
            { id: "1", title: "TNDS BB xe máy" },
            { id: "2", title: "TNDS BB ô tô" },
            { id: "3", title: "Master Rider" },
            { id: "4", title: "Tai nạn hộ gia đình" },
            { id: "5", title: "Tomato" },
            { id: "6", title: "Vật chất ô tô" },
            { id: "7", title: "VBI Care" },
            { id: "8", title: "Family Care" },
            { id: "9", title: "Home Care" },
            { id: "10", title: "Bảo hiểm du lịch" },
            { id: "11", title: "Bảo hiểm nhà tư nhân" }

        ]

    } catch (err) {
        return rejectWithValue(err.message || 'Error')
    }
});


export const getDropListAffiliateSources = createAsyncThunk('dashboard/getDropListAffiliateSources', async (_, { rejectWithValue }) => {
    try {
        return [
            { id: "1", title: "Zalo" },
            { id: "2", title: "Instagram" },
            { id: "3", title: "Threads" },
            { id: "4", title: "Facebook" }
        ]

    } catch (err) {
        return rejectWithValue(err.message || 'Error')
    }
});


export const search = createAsyncThunk('dashboard/search', async ({_, rejectWithValue }) => {
    // const { filters, userToken } = data
    try {
        return {
            dashboardGC: [
                { id: "1", title: "Tổng lượt click", value: 19810 }, { id: "2", title: "Tổng lượt xem", value: 10935 },
                { id: "3", title: "Tổng số data", value: 94 }, { id: "4", title: "Tổng số đơn", value: 823 },
                { id: "5", title: "Tổng doanh thu", value: 9423000 }, { id: "6", title: "Tổng thu nhập", value: 723000 },
            ]
            ,

            lineChart: {

                views: [
                    { date: 1, value: 400000 }, { date: 2, value: 250000 }, { date: 3, value: 250000 }, { date: 4, value: 270000 }, { date: 5, value: 300000 },
                    { date: 6, value: 280000 }, { date: 7, value: 250000 }, { date: 8, value: 350000 }, { date: 9, value: 380000 }, { date: 10, value: 360000 },
                    { date: 11, value: 200000 }, { date: 12, value: 370000 }, { date: 13, value: 400000 }, { date: 14, value: 410000 }, { date: 15, value: 420000 },
                    { date: 16, value: 430000 }, { date: 17, value: 400000 }, { date: 18, value: 410000 }, { date: 19, value: 450000 }, { date: 20, value: 470000 },
                    { date: 21, value: 1000000 }, { date: 22, value: 1500000 }, { date: 23, value: 1700000 }, { date: 24, value: 2000000 }, { date: 25, value: 2200000 },
                    { date: 26, value: 2300000 }, { date: 27, value: 2500000 }, { date: 28, value: 2600000 }, { date: 29, value: 2700000 }, { date: 30, value: 10000000 }
                ]
                ,

                purchases: [
                    { date: 1, value: 100000 }, { date: 2, value: 150000 }, { date: 3, value: 150000 }, { date: 4, value: 170000 }, { date: 5, value: 200000 },
                    { date: 6, value: 200000 }, { date: 7, value: 250000 }, { date: 8, value: 250000 }, { date: 9, value: 270000 }, { date: 10, value: 300000 },
                    { date: 11, value: 150000 }, { date: 12, value: 300000 }, { date: 13, value: 350000 }, { date: 14, value: 370000 }, { date: 15, value: 350000 },
                    { date: 16, value: 200000 }, { date: 17, value: 250000 }, { date: 18, value: 250000 }, { date: 19, value: 270000 }, { date: 20, value: 350000 },
                    { date: 21, value: 200000 }, { date: 22, value: 250000 }, { date: 23, value: 250000 }, { date: 24, value: 270000 }, { date: 25, value: 1500000 },
                    { date: 26, value: 1300000 }, { date: 27, value: 1700000 }, { date: 28, value: 1600000 }, { date: 29, value: 2000000 }, { date: 30, value: 2500000 }
                ]

            }
            ,

            products:
                [
                    { id: "1", name: "Family Care", totalClicks: 98340, totalOrders: 3124000, totalRevenue: 1301636000 },
                    { id: "2", name: "BH GC Care", totalClicks: 78543, totalOrders: 1924000, totalRevenue: 931364000 },
                    { id: "3", name: "Bệnh hiểm nghèo", totalClicks: 65364, totalOrders: 974000, totalRevenue: 801636000 },
                    { id: "4", name: "BH BM Care", totalClicks: 58478, totalOrders: 843000, totalRevenue: 701300000 },
                    { id: "5", name: "BH An gia", totalClicks: 48975, totalOrders: 776000, totalRevenue: 601237000 },
                    { id: "6", name: "BH Sinh mạng", totalClicks: 37064, totalOrders: 667000, totalRevenue: 576646000 }
                ]
            ,

            contributors:
                [
                    { id: "1", name: "Vương Anh Dũng", totalClicks: 198320, totalOrders: 198340, totalRevenue: 1301636000 },
                    { id: "2", name: "Đinh Thị Thuý Oanh", totalClicks: 128543, totalOrders: 924000, totalRevenue: 907345000 },
                    { id: "3", name: "Trần Dương Khánh Linh", totalClicks: 95364, totalOrders: 874000, totalRevenue: 856375000 },
                    { id: "4", name: "Hồ Văn Duy", totalClicks: 88478, totalOrders: 743000, totalRevenue: 734965000 },
                    { id: "5", name: "Ngọc Dung", totalClicks: 78975, totalOrders: 676000, totalRevenue: 646608000 },
                    { id: "6", name: "Trinh Nguyễn", totalClicks: 67064, totalOrders: 567000, totalRevenue: 515670000 }
                ]

        }

    } catch (err) {
        return rejectWithValue(err.message || 'Error')
    }
});

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setStartDate: (state, startDate) => {
            state.filters.startDate = startDate;
        },

        setEndDate: (state, endDate) => {
            state.filters.endDate = endDate;
        },

        addProductInFilter: (state, productId) => {
            if (!state.filters.products.includes(productId)) {
                state.filters.products.push(productId);
            }
        },

        addSourceInFilter: (state, sourceId) => {
            if (!state.filters.sources.includes(sourceId)) {
                state.filters.sources.push(sourceId);
            }
        },

        removeProductInFilter: (state, productId) => {
            state.filters.products = state.filters.products.filter(id => id !== productId);
        },

        removeSourceInFilter: (state, sourceId) => {
            state.filters.sources = state.filters.sources.filter(id => id !== sourceId);
        },

        dropListProductsInitialized: (state, action) => {
            state.loading = false;
            state.dropListProducts = action.payload;
        },

        dropListAffiliateSourcesInitialized: (state, action) => {
            state.loading = false;
            state.dropListAffiliateSources = action.payload;

        },

        searchSucess: (state, action) => {
            state.loading = false;
            state.statistic = action.payload;
        },

        showLoading: (state) => {
            state.loading = true;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getDropListProducts.pending, (state) => {
                state.loading = true
            })
            .addCase(getDropListProducts.fulfilled, (state, action) => {
                state.loading = false
                state.dropListProducts = action.payload
            })
            .addCase(getDropListProducts.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(getDropListAffiliateSources.pending, (state) => {
                state.loading = true
            })
            .addCase(getDropListAffiliateSources.fulfilled, (state, action) => {
                state.loading = false
                state.dropListAffiliateSources = action.payload
            })
            .addCase(getDropListAffiliateSources.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(search.pending, (state) => {
                state.loading = true
            })
            .addCase(search.fulfilled, (state, action) => {
                state.loading = false
                state.statistic = action.payload
            })
            .addCase(search.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
    }
});

export const {
    setStartDate,
    setEndDate,
    addProductInFilter,
    addSourceInFilter,
    removeProductInFilter,
    removeSourceInFilter,
    dropListProductsInitialized,
    dropListAffiliateSourcesInitialized,
    searchSucess,
    showLoading
} = dashboardSlice.actions

export default dashboardSlice.reducer